import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export enum InteractionScreen {
  WELCOME = 0,
  HOME = 1,
  GAME = 2,
  ABOUT = 3,
  ROADMAP = 4,
  LINKS = 5,
  OPTIONS = 6,
  SANDBOX = 7,
  DEMO_SELECT = 8
}

interface IScreenInteractions {
  screen: InteractionScreen;
  screenPage: number
  optionSelected?: number
}

const initialState: IScreenInteractions = {
  screen: InteractionScreen.WELCOME,
  screenPage: 0,
  optionSelected: 0
}

const screenInteractionsSlice = createSlice({
  name: 'screen-interaction',
  initialState,
  reducers: {
    setScreen: (state, action: PayloadAction<InteractionScreen>) => {
      state.screen = action.payload;
    },
    setScreenPage: (state, action: PayloadAction<number>) => {
      state.screenPage = action.payload;
    },
    setSelectedOption: (state, action: PayloadAction<number>) => {
      state.optionSelected = action.payload;
    }
  },
})

export const { setScreen, setSelectedOption, setScreenPage } = screenInteractionsSlice.actions

export default screenInteractionsSlice.reducer